module.exports = __webpack_public_path__ + "img/blueTxt.b7e55d72.png";